import { observer } from "mobx-react";
import ScrollToTop from "./scroll-to-top";
import logo from "../resources/images/logo-noshe.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faMapMarkerAlt,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const Footer = observer(() => {
  return (
    <>
      <ScrollToTop />
      <footer
        id="contactUs"
        className="app-footer text-center text-lg-start text-white bg-default pt-1 my-5"
      >
        <section className="">
          <div className="container text-center text-md-start mt-4">
            <div className="row mt-3">
              <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold">Noshe Cambridge</h6>
                <hr
                  className="mb-4 mt-0 d-inline-block mx-auto"
                  style={{
                    backgroundColor: "var(--noshe-gold)",
                    height: "2px",
                    width: "60px",
                  }}
                />
                <p>Coffeehouse & Afghan Restaurant</p>
                <p>
                  <FontAwesomeIcon icon={faClock} className="me-2" />
                  Tuesday to Sunday: 08:00 - 23:00
                </p>
              </div>

              <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4"></div>

              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4"></div>

              <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold">Contact</h6>
                <hr
                  className="mb-4 mt-0 d-inline-block mx-auto"
                  style={{
                    backgroundColor: "var(--noshe-gold)",
                    height: "2px",
                    width: "60px",
                  }}
                />
                <p>
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                  18 Mill Road, Cambridge, CB1 3AA
                </p>
                <p>
                  <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                  Noshecambridge@gmail.com
                </p>
                <p>
                  <FontAwesomeIcon icon={faPhone} className="me-2" />
                  07964 624055
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="app-footer-bottom">
          <div className="container app-footer-bottom-inner">
            <a className="app-footer-brand" href="/">
              <img src={logo} height="60" alt="Noshe Cambridge home" />
            </a>
            <div className="app-footer-credit">
              <p>All Rights Reserved © Noshe Cambridge 2024</p>
              <p>
                Designed and maintained by{" "}
                <a href="https://pharmix.co.uk">
                  Pharmix Technologies Ltd
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
});

export default Footer;
